import { createAppSlice } from '../createAppSlice';
import { PAGINATION } from '@/constants/pagination.constant';
import { transformerArray } from '../transformer';

export type PermissionState = {
  loading: boolean;
  permissionFields: PermissionFieldType[];
  modules: PermissionData[];
  pagination: Pagination;
};

const initialState: PermissionState = {
  loading: false,
  permissionFields: [],
  modules: [],
  pagination: PAGINATION
};

export const permissionSlice = createAppSlice({
  name: 'permissions',
  initialState,
  reducers: (create) => ({
    fetchPermissionFields: create.asyncThunk(
      async (query?: Record<string, any>) => {
        const response = await apiFetcher.get('permission', { query });
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.permissionFields = transformerArray(action.payload);
          state.pagination = action.payload.paging;
        },
        rejected: (state) => {
          state.loading = false;
          state.permissionFields = [];
          state.pagination = PAGINATION;
        }
      }
    ),
    fetchPermissionModules: create.asyncThunk(
      async (query?: Record<string, any>) => {
        const response = await apiFetcher.get('module', { query });
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.modules = transformerArray(action.payload);
          state.pagination = action.payload.paging;
        },
        rejected: (state) => {
          state.loading = false;
          state.modules = [];
          state.pagination = PAGINATION;
        }
      }
    )
  }),

  selectors: {
    watchPermissionFields: (permission) => permission.permissionFields,
    watchPermissionModules: (permission) => permission.modules,
    watchPermissionLoading: (permission) => permission.loading,
    watchPermissionPagination: (permission) => permission.pagination
  }
});

export const {
  watchPermissionFields,
  watchPermissionLoading,
  watchPermissionPagination,
  watchPermissionModules
} = permissionSlice.selectors;

export const { fetchPermissionFields, fetchPermissionModules } =
  permissionSlice.actions;
